export var MARKED_COMMENT_TYPES = {
    BEST_ANSWER: 'best_answer',
    SOLVED: 'solved',
    FEATURED: 'featured',
    PINNED: 'pinned',
    CUSTOM: 'custom',
};
//# sourceMappingURL=marked-comment-types.js.map